import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { css } from 'styled-components';
import { useThemeDefaults } from '../utils';
import { fadeIn } from '../animations';
import Box from '../Box';
import { focusWithinStyle } from '../focus';
import * as Input from './Input';
export var ChipsWrapper = useThemeDefaults(function (props) {
  return _objectSpread(_objectSpread({}, Input.formFieldStyles(props)), {}, {
    as: 'div',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    flexWrap: ' wrap',
    height: 'auto',
    width: '100%',
    borderWidth: props.theme.formField.borderWidth,
    borderRadius: props.theme.radius
  }, props.theme.chipsInput.chipsWrapper);
}, styled(Box).withConfig({
  displayName: "ChipsInputstyles__ChipsWrapper",
  componentId: "sc-1k2vigw-0"
})(focusWithinStyle));
export var ChipWrapper = useThemeDefaults(function (props) {
  return _objectSpread({
    cursor: 'default',
    backgroundColor: props.theme.colors.infoBg,
    borderRadius: props.theme.radius
  }, props.theme.chipsInput.chipWrapper);
}, styled(Box).withConfig({
  displayName: "ChipsInputstyles__ChipWrapper",
  componentId: "sc-1k2vigw-1"
})(["animation:", ";"], function (props) {
  return props.bounce ? css(["", " .3s linear"], fadeIn) : null;
}));
export var InputWrapper = useThemeDefaults(function (props) {
  return {
    flex: 'auto',
    minWidth: props.theme.chipsInput.input.minWidth
  };
}, Box);
export var StyledInput = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: theme.chipsInput.input.margin,
    backgroundColor: 'transparent',
    border: "".concat(theme.chipsInput.input.border),
    borderColor: "transparent",
    borderStyle: "none",
    focusOutline: "none",
    focusBoxShadow: "none",
    focusBorder: "none"
  };
}, Input.Text);
export var CloseButton = styled('button').withConfig({
  displayName: "ChipsInputstyles__CloseButton",
  componentId: "sc-1k2vigw-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return {
    cursor: 'pointer',
    lineHeight: '0px',
    padding: '5px',
    marginLeft: theme.chipsInput.closeButton.marginLeft
  };
});